<template>
        <div class="container-title d-flex align-items-center justify-content-start pb-2 optum-bold font-24px  gap-2">
            <div class="d-flex align-items-center">
                <DynamicIcon :icon="icon" classString="container-title-icon mt-3 mr-2"/>
                <div class="title p-0 m-0 ">{{title}}</div>
            </div>
            <div class="d-flex align-items-center gap-2">
                <slot></slot>
            </div>
        </div>
</template>

<script>
import DynamicIcon from "@/components/commons/dynamicIcon/DynamicIcon.vue";

export default {
    components: { DynamicIcon },
	props: {
        title: String,
        icon: String,
        classString: String
    }
}
</script>

<style scoped>

.gap-2 > * + * {
  margin-left: 0.5rem;
}
</style>